export enum EPromoType {
  Bank = 'bank',
  Bonus = 'bonus',
  Discount = 'discount',
  MaternalCapital = 'maternalCapital',
  MilitaryMortgage = 'militaryMortgage',
  Mortgage = 'mortgage',
}

export interface IPromo {
  authorLogoUrl?: string;
  authorName?: string;
  availableJks: IAvailableJk[];
  bank: IPromoBank | null;
  banks: IPromoBank[];
  companyId: number | null;
  description?: string;
  end?: string;
  features: IPromoFeature[];
  isFromBank: boolean;
  isFromBuilder: boolean;
  name: string;
  promoId: number;
  promoImage?: string;
  promoType: EPromoType;
  start?: string;
  subtitle?: string;
}

export interface IAvailableJk {
  id: number;
  link: string;
  name: string;
}

export interface IPromoBank {
  cianMortgagePartnerLink?: string;
  id: number;
  logoUrl?: string;
  name: string;
  secondRoundImageUrl?: string;
  secondSquareImageUrl?: string;
}

export interface IPromoFeature {
  name: string;
  value: string;
}
